const DEFAULT_GST_RATE = 18;

const GST_CLASSIFICATIONS = Object.freeze([
  { value: 'unclassified', label: 'Unclassified / fallback', hsnCode: '', gstRate: 18 },
  { value: 'crochet_textile_under_1000', label: 'Crochet / textile article · up to ₹1,000', hsnCode: '6307', gstRate: 5 },
  { value: 'crochet_textile_over_1000', label: 'Crochet / textile article · above ₹1,000', hsnCode: '6307', gstRate: 12 },
  { value: 'crochet_toy_plushie', label: 'Crochet toy / plushie', hsnCode: '9503', gstRate: 12 },
  { value: 'straw_natural_fibre', label: 'Straw / natural-fibre craft', hsnCode: '4601/4602', gstRate: 5 },
  { value: 'natural_dried_flowers', label: 'Natural dried flowers / foliage', hsnCode: '4601/4602', gstRate: 5 },
  { value: 'artificial_flowers', label: 'Artificial flowers / foliage', hsnCode: '6702', gstRate: 18 },
  { value: 'glass_art', label: 'Glass artware', hsnCode: '7020', gstRate: 12 },
  { value: 'ceramic_ornamental', label: 'Ceramic ornamental article', hsnCode: '6913', gstRate: 12 },
  { value: 'clay_terracotta', label: 'Clay / terracotta article', hsnCode: '6912', gstRate: 12 },
  { value: 'clay_lamp_or_idol', label: 'Earthen clay lamp / clay idol', hsnCode: '6912', gstRate: 0 },
  { value: 'resin_plastic', label: 'Resin / plastic article', hsnCode: '3926', gstRate: 18 },
  { value: 'mixed_gift_set', label: 'Mixed gift set · verify principal supply', hsnCode: '', gstRate: 18 },
  { value: 'custom', label: 'Custom HSN / rate', hsnCode: '', gstRate: 18 },
]);

const getGstClassification = (value) =>
  GST_CLASSIFICATIONS.find((item) => item.value === value) || GST_CLASSIFICATIONS[0];

module.exports = {
  DEFAULT_GST_RATE,
  GST_CLASSIFICATIONS,
  getGstClassification,
};
